import React from 'react'
import { Col, Row } from 'react-bootstrap'
import DarkCard from './DarkCard'

const AlgoritmosList = () =>{
    return(
        <>
            <div className = "bg-svg py-5">
        <div className = "container mt-5">
            <div className = "text-white text-center">
                <h1>Algoritmos</h1>
                <p>Programas que replican algoritmos populares</p>
            </div>
            <Row xs={1} md={3}>
                <Col>
                    <DarkCard  Link = "/emisor-crc" title = " Emisor-CRC-Hamming" p = "Simulador que codifica caracteres por medio de los algoritmos CRC y Hamming "/>
                </Col>
                <Col>
                    <DarkCard  Link = "/receptor-crc" title = "Receptor-CRC-Hamming" p = "Decodificador de caracteres que generados al aplicar CRC y hamming a un carácter "/>
                </Col>
                <Col>
                    <DarkCard  Link = "/ordenar-ips" title = "Ordenar IPs" p = "Útil para acomodar IPs dependiendo de la máscara de red, acomodando cada IP con su subred"/>
                </Col>
                <Col>
                    <DarkCard  Link = "/multiplicador" title = "Multiplicador constante" p = "Un generador de números pseudo aleatorios por medio del método de multiplicación constante"/>
                </Col>
                <Col>
                    <DarkCard  Link = "/convertir-numeros" title = "Convertir números" p = "Convertidor de números decimales, hexadecimales, octales y binarios"/>
                </Col>
                <Col>
                    <DarkCard  Link = "/cesar-encrypt" title = "Cifrado de césar" p = "Algoritmo para cifrar textos por el método césar"/>
                </Col>
            </Row>    
        </div>
             
        </div>
        </>
    )
}

export default AlgoritmosList